export default function Popup({ children }: { children: React.ReactNode }) {
  return (
    <div className='absolute left-1/2 transition-transform origin-top top-full -translate-x-1/2 scale-y-0 group-hover/popup:scale-y-100 group-hover/popup:pt-2'>
      <i className='w-0 h-0 absolute border-8 -translate-1/2 border-transparent border-b-white top-0 left-1/2' />
      <div className='bg-white rounded-sm'>{children}</div>
    </div>
  )
}

export const PopupWrapClassName = 'group/popup relative'
